import { useCallback } from 'react';
// eslint-disable-next-line @direct-frontend/modules/slice-boundaries -- нужно подумать как инвалидировать кэш запросов между разными сущностями
import { invalidateCacheCategoryList } from '#entities/category';
import { type OpenApiSchemaProductVariant } from '#shared/api/schema';
import { showError, showSuccess } from '#shared/lib/toast';
import { updateProductVariantsStatuses } from '../api';

export function useProductVariantMenuRecoverAction(
    variantId: string | undefined,
    onStatusChanged?: (newStatus: OpenApiSchemaProductVariant['status']) => void
) {
    return useCallback(async () => {
        if (!variantId) {
            return;
        }

        const newStatus = 'HIDDEN';

        try {
            await updateProductVariantsStatuses({
                variant_ids: [],
                target_status: newStatus,
                query: {
                    variant_ids: [variantId],
                    statuses: ['ARCHIVED'],
                },
            });
            invalidateCacheCategoryList();
            showSuccess('Товар восстановлен');
            onStatusChanged?.(newStatus);
        } catch (e) {
            showError(
                {
                    label: 'Произошла ошибка при восстановлении товара, попробуйте еще раз',
                },
                e
            );
        }
    }, [variantId, onStatusChanged]);
}
